import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "@bfx/primeng/inputtext";
import { TranslateModule } from "@ngx-translate/core";

import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";
import { BaseComponentsModule } from "../../shared/base-components/base-components.module";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BfxOrderFillNowComponent } from "app/bfx-order-fill-now/bfx-order-fill-now.component";
import { RadioButtonModule } from "@bfx/primeng/radiobutton";
import { BfxInterfaceControlsModule } from "app/bfx-interface-controls/bfx-interface-controls.module";
import { ButtonModule } from "@bfx/primeng/button";
import { BfxOrderFillNowService } from "app/bfx-order-fill-now/services/bfx-order-fill-now.service";
import { CheckboxModule } from "@bfx/primeng/checkbox";

@NgModule({
  imports: [
    CommonModule,
    BfxSharedModule,
    TranslateModule,
    FormsModule,
    InputTextModule,
    BaseComponentsModule,
    NativeDesktopModule,
    RadioButtonModule,
    BfxInterfaceControlsModule,
    BfxElementsLibraryModule,
    ButtonModule,
    CheckboxModule,
  ],
  providers: [BfxOrderFillNowService],
  declarations: [BfxOrderFillNowComponent],
  exports: [BfxOrderFillNowComponent],
  bootstrap: [BfxOrderFillNowComponent],
})
export class BfxOrderFillNowModule {}
